<template>
  <div>
    <cool-select
      :scrollItemsLimit="10000"
      :scrollItemsLimitAddAfterScroll="10000"
      :arrowsDisableInstantSelection="true"
      :placeholder="placeholder || 'Busque pelo nome clique para selecionar'"
      v-model="entity"
      v-validate="validate"
      :name="field"
      :items="list"
      item-text="title"
      @select="addItem(); callback(entity)"
      inputForTextClass="form-control"
    >
      <template slot="item" slot-scope="{ item: option }">
        <div style="display: flex; align-items: center;">
          <img v-if="option.picture" :src="baseUrl + option.picture" />
          <div>
            <strong>{{ option.title }}</strong>
            <br v-if="option.description && option.description" />
            <small>{{ option.description }}</small>
          </div>
        </div>
      </template>
      <template slot="no-data">
        <br />
        <h5 class="text-center">Nenhum item encontrado</h5>
        <br />
      </template>
    </cool-select>
    <span v-for="(err, index) in veeErrors" :key="index">
      <span class="text-danger" v-if="err.field == field">{{ err.msg }}</span>
    </span>
  </div>
</template>

<script>
import { CoolSelect } from "vue-cool-select";
import Vue from "vue";

export default {
  name: "form-entity-select",
  props: [
    "items",
    "type",
    "form",
    "field",
    "input",
    "validate",
    "placeholder",
    "clearAfterSelect",
    "itemsToExclude"
  ],
  inject: ["$validator"],
  data() {
    return {
      list: [],
      entity: [],
    };
  },
  created() {
    this.createList()
  },
  methods: {
    async createList(){
        if (this.items) {
      this.list = this.items.sort(function (a, b) {
        return a.title.localeCompare(b.title);
      });
    } else {
      switch (this.type) {
        case "organizations":
          this.list = (await this.loadList("organizations"))
            .map((organization) => ({
              id: organization._id,
              title: organization.name,
              description: organization.description,
              picture:
                organization.images && organization.images.length
                  ? organization.images[0].thumb
                  : "",
            }))
            .sort(function (a, b) {
              return a.title.localeCompare(b.title);
            });
          break;
        case "suppliers":
          this.list = (await this.loadList("suppliers"))
            .map((supplier) => ({
              id: supplier._id,
              title: supplier.name,
              description: supplier.description,
              picture:
                supplier.images && supplier.images.length
                  ? supplier.images[0].thumb
                  : "",
            }))
            .sort(function (a, b) {
              return a.title.localeCompare(b.title);
            });
          break;
        case "product_variations":
          this.list = (await this.loadList("product_variations"))
            .map((product_variation) => ({
              id: product_variation._id,
              title: product_variation.name,
              description: product_variation.description,
              picture:
                product_variation.images && product_variation.images.length
                  ? product_variation.images[0].thumb
                  : "",
            }))
            .sort(function (a, b) {
              return a.title.localeCompare(b.title);
            });
          break;
        case "offers":
          this.list = (await this.loadList("offers"))
            .filter((offer) =>
              !this.itemsToExclude.find(
                (itemToExclude) => itemToExclude.offer._id == offer._id
              )
            )
            .map(({ product_variation, ...offer }) => ({
              id: product_variation._id,
              title: product_variation.name,
              description: `${
                product_variation.description
              } (Preço: ${Vue.options.filters.currency(
                offer.final_price || 0,
                "R$ ",
                2,
                { decimalSeparator: ",", thousandsSeparator: "." }
              )} Fabricação: ${this.$moment(offer.manufacturing_date).format(
                "DD/MM/YYYY"
              )})`,
              offer: { product_variation, ...offer },
              picture:
                product_variation.images && product_variation.images.length
                  ? product_variation.images[0].thumb
                  : "",
            }))
            .sort(function (a, b) {
              return a.title.localeCompare(b.title);
            });

          break;
        case "users":
          this.list = (await this.loadList("users"))
            .map((user) => ({
              id: user._id,
              title: user.name,
              email: user.email,
              description: user.nickname,
              picture: user.image ? user.image.thumb : "",
            }))
            .sort(function (a, b) {
              return a.title.localeCompare(b.title);
            });
          break;
        case "sellers":
          this.list = (await this.loadList("sellers"))
            .map((seller) => ({
              id: seller._id,
              title: seller.name,
              email: seller.email,
              description: seller.nickname,
              picture: seller.image ? seller.image.thumb : "",
            }))
            .sort(function (a, b) {
              return a.title.localeCompare(b.title);
            });
          break;
      }
    }
    if (this.form[this.field] && this.form[this.field].length) {
      this.entity = this.list.find((item) => {
        return item.id == this.form[this.field];
      });
    }
    },
    addItem() {
      this.form[this.field] = this.entity.id;
    },
    callback(entity) {
      if (this.input) {
        this.input(entity);
      }
      if (this.clearAfterSelect) {
        this.entity = [];
      }
    },
  },
  watch: {
    items: function (newVal) {
      this.list = newVal;
    },
    itemsToExclude: function (newVal){
      this.itemsToExclude = newVal
      this.createList()
    }
  },
  components: {
    CoolSelect,
  },
};
</script>
